import { useCallback, useEffect, useState } from 'react';
import api from './api';

// Accounting months are CLOSED unless finance has explicitly opened them, so any
// screen that writes into a month must offer only the open ones rather than let the
// user pick a month the API will reject on save. This is the single source for that
// list: `months` newest-first, `current` the one to default to.
export const useOpenMonths = () => {
  const [months, setMonths] = useState([]);
  const [current, setCurrent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    api.get('/employees/payroll/months')
      .then(({ data }) => { if (live) { setMonths(data.months || []); setCurrent(data.current || ''); } })
      .catch(() => {})
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, []);

  // Accepts 'YYYY-MM' or any 'YYYY-MM-DD…' date string.
  const isOpen = useCallback((value) => months.includes(String(value || '').slice(0, 7)), [months]);

  return { months, current, loading, isOpen };
};

export default useOpenMonths;
